/**
 * Document Layer executor port registration — I3 stream_spawn · I4 workflow_publish
 */

import {
  registerStreamSpawnExecutorPort,
  registerWorkflowPublishExecutorPort,
  type DocumentExecutorInput,
  type DocumentExecutorResult,
} from '@shared/document/resolve-executor';
import { spawnAppealDocumentStream } from './appealDocumentApi';
import { publishKnowledgeDocument } from './knowledgeDocumentApi';

let registered = false;

export function registerDocumentExecutorPorts(): void {
  if (registered) return;

  registerStreamSpawnExecutorPort({
    spawn: async (input: DocumentExecutorInput): Promise<DocumentExecutorResult> => {
      return spawnAppealDocumentStream(input);
    },
  });

  registerWorkflowPublishExecutorPort({
    publish: async (input: DocumentExecutorInput): Promise<DocumentExecutorResult> => {
      return publishKnowledgeDocument(input);
    },
  });

  registered = true;
}

export function resetDocumentExecutorPortsForTests(): void {
  registered = false;
}
